<script>
    import { car_encounters } from './store.js';
    import Viz7 from './Viz7.svelte';

    $: datapoints = $car_encounters;
    let car_on_top = 6;
    let datapoint_under_mouse = {}
    // $: console.log(sorted_large_datapoints)

    let cars = []
    $: cars = [...new Set(datapoints.map(d => { return d.cars }).flat())]
            .sort((a, b) => a - b)
    $: large_datapoints = datapoints.filter(d => { return d.num_overlaps > 5 })

    const checkIfCarInEncounter = function(car, encounter) {
        if ( encounter["cars"].includes(car) ) {
            return true
        }
        return false
    }

    let sorted_large_datapoints = []
    $: sorted_large_datapoints = [...large_datapoints.filter(d => { return checkIfCarInEncounter(car_on_top, d)}),
                                  ...large_datapoints.filter(d => { return !checkIfCarInEncounter(car_on_top, d)})]//.slice(1,3)
</script>

<style>
    text {
        font-size: small;
        cursor: pointer;
    }
</style>

Click on car number to bring all groups with that car to the top.<br/>
<svg width=1200 height=540>
    {#each cars as car, i}
        <text x=0 y=0
              transform={"translate(" + (15+i*15) + ",40) rotate(270)"}
              on:click={e => car_on_top = car}
        >{car}</text>
    {/each}

    <g transform="translate(0,50)">
        {#each sorted_large_datapoints as datapoint,i (datapoint["cars"])}
            <g on:mousemove={(e) => { datapoint_under_mouse = datapoint } }>
                <Viz7 cars={cars} datapoint={datapoint} y_offset={i} />
            </g>
        {/each}
    </g>
</svg>

<div id="details">
    <h4>Details</h4>
    Cars: {datapoint_under_mouse["cars"]}<br/>
    Number of encounters: {datapoint_under_mouse["num_overlaps"]}
</div>